/*
 * Forgeline Dealers Data
 * ----------------------
 * Updated from Forgeline_Dealer_Data_-_Marked_Up.xlsx
 * Total: 109 ACTIVE dealers across 11 countries
 * (20 inactive dealers removed per client request)
 * 
 * To update: Edit the arrays below and re-upload to Shopify Assets.
 * Map location: lat/lng were looked up from "geocoded_address". If you add a dealer or
 * change an address, you can leave lat/lng as they are (or omit them) - the dealer page
 * notices the address no longer matches and looks up the new street address itself.
 */

window.GTUDealersData = {
  "usa": [
    {
      "name": "111 Motorcars",
      "address": "111 Alpha Dr",
      "city": "Franklin",
      "state": "Tennessee",
      "zip": "37064",
      "country": "United States",
      "phone": "(629) 312-1110",
      "website": "https://www.111motorcars.com/",
      "lat": 35.897241,
      "lng": -86.874487,
      "geocoded_address": "111 Alpha Dr, Franklin, Tennessee, 37064, United States"
    },
    {
      "name": "ABC Performance",
      "address": "6830 Lothrop Rd",
      "city": "Imlay City",
      "state": "Michigan",
      "zip": "48444",
      "country": "United States",
      "phone": "(810) 724-0099",
      "website": "https://abcperformance.net/",
      "lat": 43.114847,
      "lng": -83.078502,
      "geocoded_address": "6830 Lothrop Rd, Imlay City, Michigan, 48444, United States"
    },
    {
      "name": "AMS Performance",
      "address": "500 N. Raddant Rd",
      "city": "Batavia",
      "state": "Illinois",
      "zip": "60510",
      "country": "United States",
      "phone": "(847) 709-0530",
      "website": "https://www.amsperformance.com/",
      "lat": 41.856506,
      "lng": -88.292411,
      "geocoded_address": "500 N. Raddant Rd, Batavia, Illinois, 60510, United States"
    },
    {
      "name": "AWE Tuning",
      "address": "2385-C Maryland Road",
      "city": "Willow Grove",
      "state": "Pennsylvania",
      "zip": "19090",
      "country": "United States",
      "phone": "(888) 565-2257",
      "website": "https://www.awe-tuning.com/",
      "lat": 40.161093,
      "lng": -75.135975,
      "geocoded_address": "2385-C Maryland Road, Willow Grove, Pennsylvania, 19090, United States"
    },
    {
      "name": "Abel Chevrolet Buick Co",
      "address": "280 N Front St",
      "city": "Rio Vista",
      "state": "California",
      "zip": "94571",
      "country": "United States",
      "phone": "(707) 507-5055",
      "website": "https://www.abelgm.com/",
      "lat": 38.160182,
      "lng": -121.688231,
      "geocoded_address": "280 N Front St, Rio Vista, California, 94571, United States"
    },
    {
      "name": "Advanced Modern Performance",
      "address": "247 Gilbert Cir.",
      "city": "Grand Prairie",
      "state": "Texas",
      "zip": "75050",
      "country": "United States",
      "phone": "(972) 313-1199",
      "website": "https://advancedmodernperformance.com/",
      "lat": 32.812076,
      "lng": -97.006461,
      "geocoded_address": "247 Gilbert Cir., Grand Prairie, Texas, 75050, United States"
    },
    {
      "name": "Auto Assets",
      "address": "378 W. Olentangy St",
      "city": "Powell",
      "state": "Ohio",
      "zip": "43065",
      "country": "United States",
      "phone": "(614) 793-1050",
      "website": "https://www.autoassets.com/",
      "lat": 40.158942,
      "lng": -83.085071,
      "geocoded_address": "378 W. Olentangy St, Powell, Ohio, 43065, United States"
    },
    {
      "name": "Auto Edge",
      "address": "900 Wildwood Road",
      "city": "Mahtomedi",
      "state": "Minnesota",
      "zip": "55115",
      "country": "United States",
      "phone": "(651) 571-9540",
      "website": "https://autoedgemn.com/",
      "lat": 45.049849,
      "lng": -92.982785,
      "geocoded_address": "900 Wildwood Road, Mahtomedi, Minnesota, 55115, United States"
    },
    {
      "name": "AutoQuest Motorsports",
      "address": "14498 S. Tamiami Trail",
      "city": "Fort Myers",
      "state": "Florida",
      "zip": "33912",
      "country": "United States",
      "phone": "(239) 432-1700",
      "website": "https://www.autoquestcars.com/",
      "lat": 26.531887,
      "lng": -81.872354,
      "geocoded_address": "14498 S. Tamiami Trail, Fort Myers, Florida, 33912, United States"
    },
    {
      "name": "Autometrics",
      "address": "118 Fabricators St",
      "city": "Summerville",
      "state": "South Carolina",
      "zip": "29483",
      "country": "United States",
      "phone": "(843) 763-7356",
      "website": "https://autometricsmotorsports.com/",
      "lat": 33.053911,
      "lng": -80.223347,
      "geocoded_address": "118 Fabricators St, Summerville, South Carolina, 29483, United States"
    },
    {
      "name": "B Rod or Custom",
      "address": "7209 Old Rutledge Pike",
      "city": "Knoxville",
      "state": "Tennessee",
      "zip": "37924",
      "country": "United States",
      "phone": "(865) 281-8821",
      "website": "https://www.b-rodorcustom.com/",
      "lat": 36.036489,
      "lng": -83.820816,
      "geocoded_address": "7209 Old Rutledge Pike, Knoxville, Tennessee, 37924, United States"
    },
    {
      "name": "Bent Metal Customs",
      "address": "545 W. Third Street",
      "city": "Lansdale",
      "state": "Pennsylvania",
      "zip": "19446",
      "country": "United States",
      "phone": "(215) 412-9333",
      "website": "http://bentmetalcustoms.com/",
      "lat": 40.247627,
      "lng": -75.287796,
      "geocoded_address": "545 W. Third Street, Lansdale, Pennsylvania, 19446, United States"
    },
    {
      "name": "Big Oak Garage",
      "address": "6818 US Hwy 278 East",
      "city": "Hokes Bluff",
      "state": "Alabama",
      "zip": "35903",
      "country": "United States",
      "phone": "(256) 494-5657",
      "website": "https://bigoakgarage.com/",
      "lat": 33.985048,
      "lng": -85.8464,
      "geocoded_address": "6818 US Hwy 278 East, Hokes Bluff, Alabama, 35903, United States"
    },
    {
      "name": "Bodymotion",
      "address": "21 Cindy Lane",
      "city": "Ocean Township",
      "state": "New Jersey",
      "zip": "07712",
      "country": "United States",
      "phone": "(732) 493-2700",
      "website": "https://www.bodymotion.com/",
      "lat": 40.266621,
      "lng": -74.047968,
      "geocoded_address": "21 Cindy Lane, Ocean Township, New Jersey, 07712, United States"
    },
    {
      "name": "Cantrell Motorsports",
      "address": "1655 139th Pl N.E.",
      "city": "Bellevue",
      "state": "Washington",
      "zip": "98005",
      "country": "United States",
      "phone": "(425) 746-8960",
      "website": "https://cantrellmotorsport.com/",
      "lat": 47.625015,
      "lng": -122.156184,
      "geocoded_address": "1655 139th Pl N.E., Bellevue, Washington, 98005, United States"
    },
    {
      "name": "Chris Holstrom Concepts",
      "address": "133 23rd St SE",
      "city": "Puyallup",
      "state": "Washington",
      "zip": "98372",
      "country": "United States",
      "phone": "(253) 435-5385",
      "website": "https://chrisholstromconcepts.com/",
      "lat": 47.189625,
      "lng": -122.264397,
      "geocoded_address": "133 23rd St SE, Puyallup, Washington, 98372, United States"
    },
    {
      "name": "Cicio Performance of Florida",
      "address": "3632 131st Ave N",
      "city": "Clearwater",
      "state": "Florida",
      "zip": "33762",
      "country": "United States",
      "phone": "(813) 586-2305",
      "website": "https://cicioperformance.com/",
      "lat": 27.891074,
      "lng": -82.682167,
      "geocoded_address": "3632 131st Ave N, Clearwater, Florida, 33762, United States"
    },
    {
      "name": "Cicio Performance of Georgia",
      "address": "2130 Brandon Trail",
      "city": "Alpharetta",
      "state": "Georgia",
      "zip": "30004",
      "country": "United States",
      "phone": "(855) 854-0123",
      "website": "https://cicioperformance.com/",
      "lat": 34.140539,
      "lng": -84.239728,
      "geocoded_address": "2130 Brandon Trail, Alpharetta, Georgia, 30004, United States"
    },
    {
      "name": "Cicio Performance of Virginia",
      "address": "1224 Executive Boulevard - STE 106",
      "city": "Chesapeake",
      "state": "Virginia",
      "zip": "23320",
      "country": "United States",
      "phone": "(757) 550-4485",
      "website": "https://cicioperformance.com/",
      "lat": 36.764033,
      "lng": -76.23479,
      "geocoded_address": "1224 Executive Boulevard - STE 106, Chesapeake, Virginia, 23320, United States"
    },
    {
      "name": "Classic BMW",
      "address": "6800 N. Dallas Parkway",
      "city": "Plano",
      "state": "Texas",
      "zip": "75024",
      "country": "United States",
      "phone": "(214) 778-2600",
      "website": "https://www.sewell.com/locations/bmw-of-plano/",
      "lat": 33.066446,
      "lng": -96.821157,
      "geocoded_address": "6800 N. Dallas Parkway, Plano, Texas, 75024, United States"
    },
    {
      "name": "Climaxx Motorsports",
      "address": "4724 Mary Ingles Hwy",
      "city": "Highland Heights",
      "state": "Kentucky",
      "zip": "41076",
      "country": "United States",
      "phone": "(859) 866-4323",
      "website": "https://www.climaxxmotorsports.com/",
      "lat": 39.039686,
      "lng": -84.410808,
      "geocoded_address": "4724 Mary Ingles Hwy, Highland Heights, Kentucky, 41076, United States"
    },
    {
      "name": "Competition Motorsport Austin",
      "address": "12001 Burnet Rd Suite F",
      "city": "Austin",
      "state": "Texas",
      "zip": "78753",
      "country": "United States",
      "phone": "(844) 438-7244",
      "website": "https://competitionmotorsport.com/",
      "lat": 30.407481,
      "lng": -97.71337,
      "geocoded_address": "12001 Burnet Rd Suite F, Austin, Texas, 78753, United States"
    },
    {
      "name": "Country Corvette",
      "address": "325 Westtown Road #1",
      "city": "West Chester",
      "state": "Pennsylvania",
      "zip": "19382",
      "country": "United States",
      "phone": "(610) 696-7888",
      "website": "https://www.countycorvette.com/",
      "lat": 39.960701,
      "lng": -75.585965,
      "geocoded_address": "325 Westtown Road #1, West Chester, Pennsylvania, 19382, United States"
    },
    {
      "name": "Custom Wheels for Less",
      "address": "Vineyard Drive",
      "city": "Medina",
      "state": "Ohio",
      "zip": "44256",
      "country": "United States",
      "phone": "(440) 915-6166",
      "website": "https://www.customwheelsforless.com/",
      "lat": 41.113247,
      "lng": -81.87656,
      "geocoded_address": "Vineyard Drive, Medina, Ohio, 44256, United States"
    },
    {
      "name": "D&Z Customs",
      "address": "",
      "city": "West Bend",
      "state": "Wisconsin",
      "zip": "53090",
      "country": "United States",
      "phone": "(262) 347-9741",
      "website": "http://dandzcustoms.com/",
      "lat": 43.425278,
      "lng": -88.183428,
      "geocoded_address": "West Bend, Wisconsin, 53090, United States"
    },
    {
      "name": "Deman Motorsports",
      "address": "530 N Highland Ave",
      "city": "Nyack",
      "state": "New York",
      "zip": "10960",
      "country": "United States",
      "phone": "(845) 727-3070",
      "website": "https://demanmotorsport.com/",
      "lat": 41.111605,
      "lng": -73.927853,
      "geocoded_address": "530 N Highland Ave, Nyack, New York, 10960, United States"
    },
    {
      "name": "Detroit Speed, Inc.",
      "address": "185 McKenzie Rd",
      "city": "Mooresville",
      "state": "North Carolina",
      "zip": "28115",
      "country": "United States",
      "phone": "(704) 662-3272",
      "website": "https://detroitspeed.com/",
      "lat": 35.618815,
      "lng": -80.815901,
      "geocoded_address": "185 McKenzie Rd, Mooresville, North Carolina, 28115, United States"
    },
    {
      "name": "Deviate Motoring",
      "address": "",
      "city": "Conroe",
      "state": "Texas",
      "zip": "77385",
      "country": "United States",
      "phone": "(832) 457-6391",
      "website": "https://www.dv8motoring.com/",
      "lat": 30.196998,
      "lng": -95.425376,
      "geocoded_address": "Conroe, Texas, 77385, United States"
    },
    {
      "name": "Dinan Engineering Inc.",
      "address": "4800 U.S. Hwy 280 W",
      "city": "Opelika",
      "state": "Alabama",
      "zip": "95037",
      "country": "United States",
      "phone": "(800) 341-5480",
      "website": "https://www.dinancars.com/",
      "lat": 32.657299,
      "lng": -85.453108,
      "geocoded_address": "4800 U.S. Hwy 280 W, Opelika, Alabama, 95037, United States"
    },
    {
      "name": "Doghouse Performance",
      "address": "9018 Performance Court 100",
      "city": "Cresson",
      "state": "Texas",
      "zip": "76035",
      "country": "United States",
      "phone": "(817) 396-4211",
      "website": "https://www.dhpmsr.com/",
      "lat": 32.525133,
      "lng": -97.615808,
      "geocoded_address": "9018 Performance Court 100, Cresson, Texas, 76035, United States"
    },
    {
      "name": "Dynamic Raceworks",
      "address": "103 W 1st Ave",
      "city": "Parkesburg",
      "state": "Pennsylvania",
      "zip": "19365",
      "country": "United States",
      "phone": "(570) 991-1747",
      "website": "https://dynamicraceworks.com/",
      "lat": 39.96056,
      "lng": -75.913751,
      "geocoded_address": "103 W 1st Ave, Parkesburg, Pennsylvania, 19365, United States"
    },
    {
      "name": "Eastside Auto Spa",
      "address": "11117 Kenwood Rd.",
      "city": "Cincinnati",
      "state": "Ohio",
      "zip": "45242",
      "country": "United States",
      "phone": "(513) 885-9147",
      "website": "https://eastsideautospa.com/",
      "lat": 39.267815,
      "lng": -84.374042,
      "geocoded_address": "11117 Kenwood Rd., Cincinnati, Ohio, 45242, United States"
    },
    {
      "name": "Esoteric Auto Detail",
      "address": "9801 Karmar Ct",
      "city": "New Albany",
      "state": "Ohio",
      "zip": "43054",
      "country": "United States",
      "phone": "(614) 855-6855",
      "website": "https://esotericdetail.com/",
      "lat": 40.087613,
      "lng": -82.795831,
      "geocoded_address": "9801 Karmar Ct, New Albany, Ohio, 43054, United States"
    },
    {
      "name": "Essex Parts Services Inc.",
      "address": "125 Hampton Court",
      "city": "Cramerton",
      "state": "North Carolina",
      "zip": "28032",
      "country": "United States",
      "phone": "(704) 824-6030",
      "website": "https://www.essexparts.com/",
      "lat": 35.235548,
      "lng": -81.073887,
      "geocoded_address": "125 Hampton Court, Cramerton, North Carolina, 28032, United States"
    },
    {
      "name": "Fabspeed Motorsport",
      "address": "155 Commerce Drive",
      "city": "Fort Washington",
      "state": "Pennsylvania",
      "zip": "19034",
      "country": "United States",
      "phone": "(267) 651-5045",
      "website": "https://www.fabspeed.com/",
      "lat": 40.136356,
      "lng": -75.204005,
      "geocoded_address": "155 Commerce Drive, Fort Washington, Pennsylvania, 19034, United States"
    },
    {
      "name": "Fatt Boyz",
      "address": "3050 Springboro Pike",
      "city": "Dayton",
      "state": "Ohio",
      "zip": "45439",
      "country": "United States",
      "phone": "(937) 294-2699",
      "website": "https://www.fattboyzdayton.com/",
      "lat": 39.711259,
      "lng": -84.216305,
      "geocoded_address": "3050 Springboro Pike, Dayton, Ohio, 45439, United States"
    },
    {
      "name": "G3 Motorsports",
      "address": "1280 Hand Ave, Unit A",
      "city": "Ormond Beach",
      "state": "Florida",
      "zip": "32174",
      "country": "United States",
      "phone": "(386) 238-9559",
      "website": "https://g3motorsportsfl.com/",
      "lat": 29.260693,
      "lng": -81.07867,
      "geocoded_address": "1280 Hand Ave, Unit A, Ormond Beach, Florida, 32174, United States"
    },
    {
      "name": "GAP Industries Inc",
      "address": "25741 Jack Rd",
      "city": "Hockley",
      "state": "Texas",
      "zip": "77447",
      "country": "United States",
      "phone": "(855) 284-5829",
      "website": "https://www.builtbygap.com/",
      "lat": 29.966521,
      "lng": -95.821336,
      "geocoded_address": "25741 Jack Rd, Hockley, Texas, 77447, United States"
    },
    {
      "name": "GMG Racing",
      "address": "3210 South Shannon Street",
      "city": "Santa Ana",
      "state": "California",
      "zip": "92704",
      "country": "United States",
      "phone": "(714) 432-1582",
      "website": "https://www.gmgracing.com/",
      "lat": 33.703747,
      "lng": -117.923497,
      "geocoded_address": "3210 South Shannon Street, Santa Ana, California, 92704, United States"
    },
    {
      "name": "GMP Performance Charlotte",
      "address": "710 Pressley Road",
      "city": "Charlotte",
      "state": "North Carolina",
      "zip": "28217",
      "country": "United States",
      "phone": "(888) 488-2028",
      "website": "https://www.gmpperformance.com/",
      "lat": 35.188265,
      "lng": -80.891658,
      "geocoded_address": "710 Pressley Road, Charlotte, North Carolina, 28217, United States"
    },
    {
      "name": "GMP Performance Lake Norman",
      "address": "292 Rolling Hill Rd",
      "city": "Mooresville",
      "state": "North Carolina",
      "zip": "28117",
      "country": "United States",
      "phone": "(704) 660-9920",
      "website": "https://www.gmpperformance.com/",
      "lat": 35.584069,
      "lng": -80.861169,
      "geocoded_address": "292 Rolling Hill Rd, Mooresville, North Carolina, 28117, United States"
    },
    {
      "name": "GMP Performance South Atlanta",
      "address": "435 Dividend Dr, Suite D",
      "city": "Peachtree City",
      "state": "Georgia",
      "zip": "30269",
      "country": "United States",
      "phone": "(678) 632-0877",
      "website": "https://www.gmpperformance.com/",
      "lat": 33.368668,
      "lng": -84.574078,
      "geocoded_address": "435 Dividend Dr, Suite D, Peachtree City, Georgia, 30269, United States"
    },
    {
      "name": "GlasWerks DMV",
      "address": "21620 Ridgetop Circle, Suite 190",
      "city": "Sterling",
      "state": "Virginia",
      "zip": "20166",
      "country": "United States",
      "phone": "(571) 370-8500",
      "website": "https://www.gwdmv.com/",
      "lat": 39.028094,
      "lng": -77.407528,
      "geocoded_address": "21620 Ridgetop Circle, Suite 190, Sterling, Virginia, 20166, United States"
    },
    {
      "name": "Hawks Motorsports",
      "address": "937 Pelzer Hwy",
      "city": "Easley",
      "state": "South Carolina",
      "zip": "29642",
      "country": "United States",
      "phone": "(864) 855-2694",
      "website": "https://www.hawksmotorsports.com/",
      "lat": 34.790954,
      "lng": -82.589104,
      "geocoded_address": "937 Pelzer Hwy, Easley, South Carolina, 29642, United States"
    },
    {
      "name": "Holohan's Hot Rod Shop",
      "address": "502 Performance Rd",
      "city": "Mooresville",
      "state": "North Carolina",
      "zip": "28115",
      "country": "United States",
      "phone": "(704) 664-4477",
      "website": "https://holohanshotrods.com/",
      "lat": 35.561255,
      "lng": -80.727483,
      "geocoded_address": "502 Performance Rd, Mooresville, North Carolina, 28115, United States"
    },
    {
      "name": "Hot Rod Transformations",
      "address": "219 Southwinds Dr.",
      "city": "Hermitage",
      "state": "Tennessee",
      "zip": "37076",
      "country": "United States",
      "phone": "(615) 444-1554",
      "website": "http://www.hotrodtransformations.com/",
      "lat": 36.109874,
      "lng": -86.523036,
      "geocoded_address": "219 Southwinds Dr., Hermitage, Tennessee, 37076, United States"
    },
    {
      "name": "JCG Restoration & Customs",
      "address": "6401 I-35 Suite 200",
      "city": "New Braunfels",
      "state": "Texas",
      "zip": "78132",
      "country": "United States",
      "phone": "(800) 832-4795",
      "website": "https://www.jcgrestorationandcustoms.com/",
      "lat": 29.647821,
      "lng": -98.196618,
      "geocoded_address": "6401 I-35 Suite 200, New Braunfels, Texas, 78132, United States"
    },
    {
      "name": "JDP Motorsports LLC",
      "address": "512 S Sheep Ln - Suite 301",
      "city": "Grantsville",
      "state": "Utah",
      "zip": "84074",
      "country": "United States",
      "phone": "(801) 545-4215",
      "website": "https://www.jdpmotorsports.com/",
      "lat": 40.584803,
      "lng": -112.373407,
      "geocoded_address": "512 S Sheep Ln - Suite 301, Grantsville, Utah, 84074, United States"
    },
    {
      "name": "JP Racecraft",
      "address": "512 S Sheep Ln - Suite 302",
      "city": "Grantsville",
      "state": "Utah",
      "zip": "84074",
      "country": "United States",
      "phone": "(801) 574-0916",
      "website": "https://jpracecraft.com/",
      "lat": 40.584803,
      "lng": -112.373407,
      "geocoded_address": "512 S Sheep Ln - Suite 302, Grantsville, Utah, 84074, United States"
    },
    {
      "name": "Kenny Brown Performance",
      "address": "1408 Sadlier Circle E Dr",
      "city": "Indianapolis",
      "state": "Indiana",
      "zip": "46239",
      "country": "United States",
      "phone": "(317) 396-2768",
      "website": "https://kennybrown.com/",
      "lat": 39.749952,
      "lng": -86.037689,
      "geocoded_address": "1408 Sadlier Circle E Dr, Indianapolis, Indiana, 46239, United States"
    },
    {
      "name": "KohR Motorsports",
      "address": "606 Commercial Dr",
      "city": "Daytona Beach",
      "state": "Florida",
      "zip": "32117",
      "country": "United States",
      "phone": "(386) 238-9910",
      "website": "https://kohrmotorsports.com/",
      "lat": 29.23522,
      "lng": -81.039864,
      "geocoded_address": "606 Commercial Dr, Daytona Beach, Florida, 32117, United States"
    },
    {
      "name": "LG Motorsports",
      "address": "704 E Houston St",
      "city": "Anna",
      "state": "Texas",
      "zip": "75409",
      "country": "United States",
      "phone": "(972) 429-1963",
      "website": "https://www.lgmotorsports.com/",
      "lat": 33.362756,
      "lng": -96.455706,
      "geocoded_address": "704 E Houston St, Anna, Texas, 75409, United States"
    },
    {
      "name": "Legacy Innovations, Inc.",
      "address": "265 Emig Road",
      "city": "Emigsville",
      "state": "Pennsylvania",
      "zip": "17318",
      "country": "United States",
      "phone": "(717) 848-2888",
      "website": "https://www.legacyinnovations.com/",
      "lat": 40.019124,
      "lng": -76.726145,
      "geocoded_address": "265 Emig Road, Emigsville, Pennsylvania, 17318, United States"
    },
    {
      "name": "Level 7 Motorsports",
      "address": "9549 Johns Ln",
      "city": "Marion",
      "state": "Illinois",
      "zip": "62959",
      "country": "United States",
      "phone": "(618) 841-1875",
      "website": "https://levelsevenmotorsports.com/",
      "lat": 37.732736,
      "lng": -89.013479,
      "geocoded_address": "9549 Johns Ln, Marion, Illinois, 62959, United States"
    },
    {
      "name": "Lingenfelter Performance Engineering",
      "address": "1557 Winchester Road",
      "city": "Decatur",
      "state": "Indiana",
      "zip": "46733",
      "country": "United States",
      "phone": "(260) 724-2552",
      "website": "https://www.lingenfelter.com/",
      "lat": 40.84575,
      "lng": -84.940194,
      "geocoded_address": "1557 Winchester Road, Decatur, Indiana, 46733, United States"
    },
    {
      "name": "Lingenfelter Performance Engineering",
      "address": "47451 Avante",
      "city": "Wixom",
      "state": "Michigan",
      "zip": "48393",
      "country": "United States",
      "phone": "(810) 355-2840",
      "website": "https://www.lingenfelter.com/",
      "lat": 42.503716,
      "lng": -83.517679,
      "geocoded_address": "47451 Avante, Wixom, Michigan, 48393, United States"
    },
    {
      "name": "MTI Racing",
      "address": "2367 Elliott Family Pkwy, Building 3",
      "city": "Dawsonville",
      "state": "Georgia",
      "zip": "30534",
      "country": "United States",
      "phone": "(770) 919-7774",
      "website": "https://mtiracing.com/",
      "lat": 34.459184,
      "lng": -84.173383,
      "geocoded_address": "2367 Elliott Family Pkwy, Building 3, Dawsonville, Georgia, 30534, United States"
    },
    {
      "name": "McCann Racing",
      "address": "8046 Frank Rd NW",
      "city": "Canton",
      "state": "Ohio",
      "zip": "44720",
      "country": "United States",
      "phone": "(330) 244-9335",
      "website": "https://mccannracing.wordpress.com/",
      "lat": 40.903443,
      "lng": -81.449872,
      "geocoded_address": "8046 Frank Rd NW, Canton, Ohio, 44720, United States"
    },
    {
      "name": "MetalWorks Classic Restoration and Performance",
      "address": "1045 Arrowsmith St",
      "city": "Eugene",
      "state": "Oregon",
      "zip": "97402",
      "country": "United States",
      "phone": "(541) 341-3372",
      "website": "https://metalworksclassics.com/",
      "lat": 44.050316,
      "lng": -123.18578,
      "geocoded_address": "1045 Arrowsmith St, Eugene, Oregon, 97402, United States"
    },
    {
      "name": "Muscle Rod Shop",
      "address": "30875 Interstate 10 Bldg. H",
      "city": "Boerne",
      "state": "Texas",
      "zip": "78006",
      "country": "United States",
      "phone": "(830) 755-7700",
      "website": "https://www.musclerodshop.com/",
      "lat": 29.747343,
      "lng": -98.699636,
      "geocoded_address": "30875 Interstate 10 Bldg. H, Boerne, Texas, 78006, United States"
    },
    {
      "name": "Obsessed Worldwide",
      "address": "6050 Executive Blvd.",
      "city": "Dayton",
      "state": "Ohio",
      "zip": "45424",
      "country": "United States",
      "phone": "(937) 760-5853",
      "website": "https://www.obsess-worldwide.com/",
      "lat": 39.870405,
      "lng": -84.126871,
      "geocoded_address": "6050 Executive Blvd., Dayton, Ohio, 45424, United States"
    },
    {
      "name": "Page Customs",
      "address": "1091 Merchants Ln.",
      "city": "Oilville",
      "state": "Virginia",
      "zip": "23129",
      "country": "United States",
      "phone": "(804) 784-5541",
      "website": "https://www.pagecustoms.com/",
      "lat": 37.695851,
      "lng": -77.762271,
      "geocoded_address": "1091 Merchants Ln., Oilville, Virginia, 23129, United States"
    },
    {
      "name": "Partsrack",
      "address": "32 Dougan Falls Ln",
      "city": "Washougal",
      "state": "Washington",
      "zip": "98671",
      "country": "United States",
      "phone": "(360) 837-3937",
      "website": "https://www.viperpartsrackamerica.com/",
      "lat": 45.672227,
      "lng": -122.154419,
      "geocoded_address": "32 Dougan Falls Ln, Washougal, Washington, 98671, United States"
    },
    {
      "name": "Paul's Automotive Engineering",
      "address": "9750 Conklin Rd",
      "city": "Cincinnati",
      "state": "Ohio",
      "zip": "45242",
      "country": "United States",
      "phone": "(513) 791-1087",
      "website": "https://paulsautomotiveengineering.com/",
      "lat": 39.235862,
      "lng": -84.377682,
      "geocoded_address": "9750 Conklin Rd, Cincinnati, Ohio, 45242, United States"
    },
    {
      "name": "Peitz Performance Tunes",
      "address": "25907 Randon Ln.",
      "city": "Tomball",
      "state": "Texas",
      "zip": "77377",
      "country": "United States",
      "phone": "(832) 370-0791",
      "website": "https://www.peitzperformancetunes.com/",
      "lat": 30.054299,
      "lng": -95.638965,
      "geocoded_address": "25907 Randon Ln., Tomball, Texas, 77377, United States"
    },
    {
      "name": "Phil's Tire Service",
      "address": "24 Center St",
      "city": "Pine Bush",
      "state": "New York",
      "zip": "12566",
      "country": "United States",
      "phone": "(845) 647-7407",
      "website": "https://philstireservice.com/",
      "lat": 41.606676,
      "lng": -74.301142,
      "geocoded_address": "24 Center St, Pine Bush, New York, 12566, United States"
    },
    {
      "name": "R&H Motor Car Group",
      "address": "32300 Aurora Road",
      "city": "Solon",
      "state": "Ohio",
      "zip": "44139",
      "country": "United States",
      "phone": "(440) 914-0000",
      "website": "https://www.motorcargroup.com/",
      "lat": 41.389756,
      "lng": -81.450993,
      "geocoded_address": "32300 Aurora Road, Solon, Ohio, 44139, United States"
    },
    {
      "name": "Radial Tire",
      "address": "9101 Brookville Rd",
      "city": "Silver Spring",
      "state": "Maryland",
      "zip": "20910",
      "country": "United States",
      "phone": "(301) 585-2740",
      "website": "https://www.radialtirecompany.com/",
      "lat": 39.004362,
      "lng": -77.050632,
      "geocoded_address": "9101 Brookville Rd, Silver Spring, Maryland, 20910, United States"
    },
    {
      "name": "Raymond's Performance",
      "address": "2699 East Main St.  Bldg A",
      "city": "Plainfield",
      "state": "Indiana",
      "zip": "46168",
      "country": "United States",
      "phone": "(317) 838-7112",
      "website": "http://www.raymondsperformance.com/",
      "lat": 39.719686,
      "lng": -86.350716,
      "geocoded_address": "2699 East Main St.  Bldg A, Plainfield, Indiana, 46168, United States"
    },
    {
      "name": "Ringbrothers",
      "address": "E4829 Highway 14",
      "city": "Spring Green",
      "state": "Wisconsin",
      "zip": "53588",
      "country": "United States",
      "phone": "(608) 588-7399",
      "website": "https://www.ringbrothers.com/",
      "lat": 43.189033,
      "lng": -90.078397,
      "geocoded_address": "E4829 Highway 14, Spring Green, Wisconsin, 53588, United States"
    },
    {
      "name": "Roadster Shop",
      "address": "28775 N. Rte 83",
      "city": "Mundelein",
      "state": "Illinois",
      "zip": "60060",
      "country": "United States",
      "phone": "(847) 949-7637",
      "website": "https://roadstershop.com/",
      "lat": 42.435383,
      "lng": -88.090375,
      "geocoded_address": "28775 N. Rte 83, Mundelein, Illinois, 60060, United States"
    },
    {
      "name": "SP Motorsports",
      "address": "1840 National Avenue",
      "city": "Hayward",
      "state": "California",
      "zip": "94545",
      "country": "United States",
      "phone": "(510) 782-0188",
      "website": "https://www.spmotorsports.com/",
      "lat": 37.649079,
      "lng": -122.122064,
      "geocoded_address": "1840 National Avenue, Hayward, California, 94545, United States"
    },
    {
      "name": "Schwartz Performance",
      "address": "455 Commanche Circle",
      "city": "Harvard",
      "state": "Illinois",
      "zip": "60033",
      "country": "United States",
      "phone": "(815) 770-0751",
      "website": "https://www.schwartzperformance.com/",
      "lat": 42.425418,
      "lng": -88.633023,
      "geocoded_address": "455 Commanche Circle, Harvard, Illinois, 60033, United States"
    },
    {
      "name": "Scot Rods Garage",
      "address": "141 Coin Street",
      "city": "Fort Worth",
      "state": "Texas",
      "zip": "76140",
      "country": "United States",
      "phone": "(817) 716-9664",
      "website": "https://www.scotrodsgarage.com/",
      "lat": 32.606012,
      "lng": -97.317609,
      "geocoded_address": "141 Coin Street, Fort Worth, Texas, 76140, United States"
    },
    {
      "name": "Sewickley Car Store",
      "address": "526 Ohio River Blvd",
      "city": "Sewickley",
      "state": "Pennsylvania",
      "zip": "15143",
      "country": "United States",
      "phone": "(888) 835-8563",
      "website": "https://sewickleycars.net/",
      "lat": 40.53573,
      "lng": -80.184106,
      "geocoded_address": "526 Ohio River Blvd, Sewickley, Pennsylvania, 15143, United States"
    },
    {
      "name": "Smitty's Custom Automotive, Ltd.",
      "address": "2961 W Twp Rd 98",
      "city": "Tiffin",
      "state": "Ohio",
      "zip": "44883",
      "country": "United States",
      "phone": "(419) 448-8080",
      "website": "https://www.smittyscustomauto.com/",
      "lat": 41.080148,
      "lng": -83.22664,
      "geocoded_address": "2961 W Twp Rd 98, Tiffin, Ohio, 44883, United States"
    },
    {
      "name": "Spade Kreations",
      "address": "11308 Dallas Blvd",
      "city": "Cincinnati",
      "state": "Ohio",
      "zip": "45231",
      "country": "United States",
      "phone": "(513) 742-9380",
      "website": "https://www.spademade.com/",
      "lat": 39.284779,
      "lng": -84.565862,
      "geocoded_address": "11308 Dallas Blvd, Cincinnati, Ohio, 45231, United States"
    },
    {
      "name": "Speedsport Tuning",
      "address": "52 Miry Brook Road",
      "city": "Danbury",
      "state": "Connecticut",
      "zip": "06810",
      "country": "United States",
      "phone": "(203) 730-0311",
      "website": "https://sstauto.com/",
      "lat": 41.367226,
      "lng": -73.485758,
      "geocoded_address": "52 Miry Brook Road, Danbury, Connecticut, 06810, United States"
    },
    {
      "name": "Speedtech Performance USA LLC",
      "address": "4160 S River Rd",
      "city": "St. George",
      "state": "Utah",
      "zip": "84790",
      "country": "United States",
      "phone": "(435) 628-4300",
      "website": "https://speedtechperformance.com/",
      "lat": 37.037827,
      "lng": -113.559371,
      "geocoded_address": "4160 S River Rd, St. George, Utah, 84790, United States"
    },
    {
      "name": "St. Paul Speed and Performance",
      "address": "9547 Dellwood Rd Ln",
      "city": "N Stillwater",
      "state": "Minnesota",
      "zip": "55082",
      "country": "United States",
      "phone": "",
      "website": "https://stpaulspeed.com/",
      "lat": 45.082781,
      "lng": -92.911605,
      "geocoded_address": "9547 Dellwood Rd Ln, N Stillwater, Minnesota, 55082, United States"
    },
    {
      "name": "Superior Concepts",
      "address": "13786 N. Lincoln Boulevard",
      "city": "Edmond",
      "state": "Oklahoma",
      "zip": "73013",
      "country": "United States",
      "phone": "(405) 285-9000",
      "website": "https://www.superiorconcepts.net/",
      "lat": 35.610773,
      "lng": -97.504576,
      "geocoded_address": "13786 N. Lincoln Boulevard, Edmond, Oklahoma, 73013, United States"
    },
    {
      "name": "TPC Racing",
      "address": "7869 Dorsey Run Rd",
      "city": "Jessup",
      "state": "Maryland",
      "zip": "20794",
      "country": "United States",
      "phone": "(410) 799-7223",
      "website": "https://www.tpcracing.com/",
      "lat": 39.1563,
      "lng": -76.775055,
      "geocoded_address": "7869 Dorsey Run Rd, Jessup, Maryland, 20794, United States"
    },
    {
      "name": "The Hot Rod Service Company",
      "address": "1090 Florence Way",
      "city": "Campbell",
      "state": "California",
      "zip": "95008",
      "country": "United States",
      "phone": "(408) 374-4452",
      "website": "http://hrsc.io/",
      "lat": 37.270684,
      "lng": -121.95066,
      "geocoded_address": "1090 Florence Way, Campbell, California, 95008, United States"
    },
    {
      "name": "The Little Speed Shop",
      "address": "1770 Emerson St",
      "city": "Rochester",
      "state": "New York",
      "zip": "14606",
      "country": "United States",
      "phone": "(585) 647-0339",
      "website": "https://www.thelittlespeedshop.com/",
      "lat": 43.174237,
      "lng": -77.678284,
      "geocoded_address": "1770 Emerson St, Rochester, New York, 14606, United States"
    },
    {
      "name": "Tim Lally Chevrolet",
      "address": "24999 Miles Rd",
      "city": "Warrensville Heights",
      "state": "Ohio",
      "zip": "44128",
      "country": "United States",
      "phone": "(440) 374-8221",
      "website": "https://www.timlally.com/",
      "lat": 41.426457,
      "lng": -81.502227,
      "geocoded_address": "24999 Miles Rd, Warrensville Heights, Ohio, 44128, United States"
    },
    {
      "name": "Tires in Motion",
      "address": "98 Scammon St Ext",
      "city": "Saco",
      "state": "Maine",
      "zip": "04072",
      "country": "United States",
      "phone": "(207) 730-0169",
      "website": "https://tiresinmotion.me/",
      "lat": 43.50394,
      "lng": -70.444912,
      "geocoded_address": "98 Scammon St Ext, Saco, Maine, 04072, United States"
    },
    {
      "name": "Turner BMW",
      "address": "9a Puzzle Ln.",
      "city": "Newton",
      "state": "New Hampshire",
      "zip": "03858",
      "country": "United States",
      "phone": "(978) 388-9595",
      "website": "https://www.turnerservice.com/",
      "lat": 42.84722,
      "lng": -71.056741,
      "geocoded_address": "9a Puzzle Ln., Newton, New Hampshire, 03858, United States"
    },
    {
      "name": "V8 Speed & Resto Shop",
      "address": "817 S Main St",
      "city": "Red Bud",
      "state": "Illinois",
      "zip": "62278",
      "country": "United States",
      "phone": "(314) 783-8325",
      "website": "https://v8speedshop.com/",
      "lat": 38.204458,
      "lng": -89.994315,
      "geocoded_address": "817 S Main St, Red Bud, Illinois, 62278, United States"
    },
    {
      "name": "Vivid Racing",
      "address": "1429 W. Scott Ave",
      "city": "Gilbert",
      "state": "Arizona",
      "zip": "85233",
      "country": "United States",
      "phone": "(866) 448-4843",
      "website": "https://www.vividracing.com/",
      "lat": 33.365388,
      "lng": -111.820932,
      "geocoded_address": "1429 W. Scott Ave, Gilbert, Arizona, 85233, United States"
    },
    {
      "name": "Wheel Enhancement",
      "address": "11014 S La Cienega Blvd",
      "city": "Lennox",
      "state": "California",
      "zip": "90304",
      "country": "United States",
      "phone": "(310) 836-8908",
      "website": "https://www.wheelenhancement.com/",
      "lat": 33.935479,
      "lng": -118.369707,
      "geocoded_address": "11014 S La Cienega Blvd, Lennox, California, 90304, United States"
    },
    {
      "name": "Wheel Experts",
      "address": "4515 McEwen Rd",
      "city": "Dallas",
      "state": "Texas",
      "zip": "75244",
      "country": "United States",
      "phone": "(817) 416-9748",
      "website": "https://www.wheelexperts.com/",
      "lat": 32.928984,
      "lng": -96.832035,
      "geocoded_address": "4515 McEwen Rd, Dallas, Texas, 75244, United States"
    },
    {
      "name": "Wheel Specialist",
      "address": "701 South Perry Lane",
      "city": "Tempe",
      "state": "Arizona",
      "zip": "85288",
      "country": "United States",
      "phone": "(480) 968-1314",
      "website": "https://www.wheelspecialists.com/",
      "lat": 33.42327,
      "lng": -111.90431,
      "geocoded_address": "701 South Perry Lane, Tempe, Arizona, 85288, United States"
    },
    {
      "name": "Wheels Performance of Miami",
      "address": "2137 NW 20th St",
      "city": "Miami",
      "state": "Florida",
      "zip": "33142",
      "country": "United States",
      "phone": "(888) 239-4335",
      "website": "https://www.wheelsperformance.com/",
      "lat": 25.794816,
      "lng": -80.230393,
      "geocoded_address": "2137 NW 20th St, Miami, Florida, 33142, United States"
    },
    {
      "name": "Wicked Whips",
      "address": "7525 Pleasant Plain Rd",
      "city": "Brookville",
      "state": "Ohio",
      "zip": "45309",
      "country": "United States",
      "phone": "(937) 833-2223",
      "website": "http://www.wickedwhipscustoms.com/",
      "lat": 39.861393,
      "lng": -84.377939,
      "geocoded_address": "7525 Pleasant Plain Rd, Brookville, Ohio, 45309, United States"
    }
  ],
  "canada": [
    {
      "name": "Braidan Motorcar",
      "address": "66 Bullock Drive, Unit 3A",
      "city": "Markham",
      "province": "Ontario",
      "postal": "L3P 3P2",
      "country": "Canada",
      "phone": "(905) 209-7979",
      "website": "https://braidanmotorsport.com/",
      "lat": 43.878448,
      "lng": -79.268107,
      "geocoded_address": "66 Bullock Drive, Unit 3A, Markham, Ontario, L3P 3P2, Canada"
    },
    {
      "name": "Davenport Motorsports",
      "address": "1530 Aviation Rd N.E.",
      "city": "Calgary",
      "province": "Alberta",
      "postal": "T2E 5T5",
      "country": "Canada",
      "phone": "(403) 274-7271",
      "website": "https://www.davenportmotorsports.com/",
      "lat": 51.096358,
      "lng": -114.026291,
      "geocoded_address": "1530 Aviation Rd N.E., Calgary, Alberta, T2E 5T5, Canada"
    },
    {
      "name": "Epic Rod & Custom",
      "address": "6328 30 St. SE #140",
      "city": "Calgary",
      "province": "Alberta",
      "postal": "T2C 1V6",
      "country": "Canada",
      "phone": "(403) 276-1101",
      "website": "https://epiccustoms.ca/",
      "lat": 50.996454,
      "lng": -113.98507,
      "geocoded_address": "6328 30 St. SE #140, Calgary, Alberta, T2C 1V6, Canada"
    },
    {
      "name": "Johnston Research & Performance, Inc.",
      "address": "2344 South Sheridan Way",
      "city": "Mississauga",
      "province": "Ontario",
      "postal": "L5J 2M4",
      "country": "Canada",
      "phone": "(905) 822-7223",
      "website": "https://www.jrponline.com/",
      "lat": 43.51717,
      "lng": -79.654112,
      "geocoded_address": "2344 South Sheridan Way, Mississauga, Ontario, L5J 2M4, Canada"
    },
    {
      "name": "Pfaff Tuning",
      "address": "101 Auto Park Circle",
      "city": "Vaughan",
      "province": "Ontario",
      "postal": "L4L 8R1",
      "country": "Canada",
      "phone": "(905) 907-1001",
      "website": "https://www.pfafftuning.com/",
      "lat": 43.783319,
      "lng": -79.548066,
      "geocoded_address": "101 Auto Park Circle, Vaughan, Ontario, L4L 8R1, Canada"
    },
    {
      "name": "TunerWorks",
      "address": "5504 - 1A Street SW",
      "city": "Calgary",
      "province": "Alberta",
      "postal": "T2H 0E7",
      "country": "Canada",
      "phone": "(403) 398-9833",
      "website": "https://tunerworks.com/",
      "lat": 51.005392,
      "lng": -114.066785,
      "geocoded_address": "5504 - 1A Street SW, Calgary, Alberta, T2H 0E7, Canada"
    }
  ],
  "australia": [
    {
      "name": "Harrop Engineering",
      "address": "96 Bell Street",
      "city": "Preston",
      "region": "Victoria",
      "postal": "3072",
      "country": "Australia",
      "phone": "03 9474 0900",
      "website": "https://www.harrop.com.au/",
      "lat": -37.745531,
      "lng": 145.025055,
      "geocoded_address": "96 Bell Street, Preston, Victoria, 3072, Australia"
    }
  ],
  "china": [
    {
      "name": "Unlimited Performance",
      "address": "No. 28 Lane 3819 Qi Xing Rd",
      "city": "Shanghai",
      "region": "SH",
      "postal": "",
      "country": "China",
      "phone": "+86 135 246 73894",
      "website": "",
      "lat": 30.80925,
      "lng": 120.84236,
      "geocoded_address": "No. 28 Lane 3819 Qi Xing Rd, Shanghai, SH, China"
    }
  ],
  "england": [
    {
      "name": "Prestige Wheel Centre",
      "address": "Unit 8 Birmingham Trade Park, Kingsbury Road",
      "city": "Erdington",
      "region": "Birmingham",
      "postal": "B24 9PS",
      "country": "England",
      "phone": "0121 377 8866",
      "website": "https://www.prestigewheelcentre.co.uk/",
      "lat": 52.516698,
      "lng": -1.811985,
      "geocoded_address": "Unit 8 Birmingham Trade Park, Kingsbury Road, Erdington, Birmingham, B24 9PS, England"
    }
  ],
  "new_zealand": [
    {
      "name": "TYREPRO Limited",
      "address": "28 Barrys Point Road",
      "city": "Takapuna",
      "region": "Auckland",
      "postal": "0622",
      "country": "New Zealand",
      "phone": "489-1118",
      "website": "https://tyrepro.co.nz/",
      "lat": -36.792695,
      "lng": 174.765375,
      "geocoded_address": "28 Barrys Point Road, Takapuna, Auckland, 0622, New Zealand"
    }
  ],
  "norway": [
    {
      "name": "Pro-Touring Support",
      "address": "Lagmoveien 13",
      "city": "Lunde",
      "region": "",
      "postal": "8 3825",
      "country": "Norway",
      "phone": "(473) 594-8237",
      "website": "http://www.protouringsupport.no/",
      "lat": 59.294355,
      "lng": 9.076135,
      "geocoded_address": "Lagmoveien 13, Lunde, 8 3825, Norway"
    }
  ],
  "russia": [
    {
      "name": "Total Race",
      "address": "Feodosiyskaya ulitsa, 1, Building 8",
      "city": "Moscow",
      "region": "",
      "postal": "121353",
      "country": "Russia",
      "phone": "",
      "website": "http://www.totalrace.ru/",
      "lat": 55.756872,
      "lng": 37.615053,
      "geocoded_address": "Feodosiyskaya ulitsa, 1, Building 8, Moscow, 121353, Russia"
    }
  ],
  "saudi_arabia": [
    {
      "name": "Advanced Motors Center",
      "address": "Ibrahim Al Asadi",
      "city": "Al Faisaliyyah",
      "region": "Riyadh",
      "postal": "12892",
      "country": "Saudi Arabia",
      "phone": "+966 53 005 0557",
      "website": "http://amc-sa.net/",
      "lat": 24.648437,
      "lng": 46.790182,
      "geocoded_address": "Ibrahim Al Asadi, Al Faisaliyyah, Riyadh, 12892, Saudi Arabia"
    }
  ],
  "taiwan": [
    {
      "name": "IXPORTER Int. Co. Ltd.",
      "address": "7F NO.12, LN 27, SEC 2, Zhongshan N Rd",
      "city": "Taipei City",
      "region": "",
      "postal": "B24 9PS",
      "country": "Taiwan",
      "phone": "",
      "website": "https://www.ixporter.com.tw/en/",
      "lat": 25.065372,
      "lng": 121.522486,
      "geocoded_address": "7F NO.12, LN 27, SEC 2, Zhongshan N Rd, Taipei City, B24 9PS, Taiwan"
    }
  ],
  "thailand": [
    {
      "name": "Autowerks Asia Co., Ltd",
      "address": "125 Sukhumvit Soi 42",
      "city": "Prakhanong, Klongtoey",
      "region": "Bangkok",
      "postal": "10110",
      "country": "Thailand",
      "phone": "(+66) 02-136-1674",
      "website": "https://www.autowerksasia.com/",
      "lat": 13.717547,
      "lng": 100.583904,
      "geocoded_address": "125 Sukhumvit Soi 42, Prakhanong, Klongtoey, Bangkok, 10110, Thailand"
    }
  ]
};
